import React from 'react'
import { useParams } from 'react-router'
import { Box, Message, Tabs } from '@workwhile/ui'
import { useUserProfileById } from 'queries/user'
import { UserDetailHeader } from './components/UserDetailHeader'
import { OverviewTab } from './tabs/OverviewTab'

export const UserDetail = () => {
  const { userId: userIdParam } = useParams<{ userId: string }>()
  const userId = userIdParam ? Number(userIdParam) : NaN

  const { data: user, isPending: isUserPending } = useUserProfileById(userId)

  if (!Number.isFinite(userId) || userId <= 0) {
    return (
      <Box p={4}>
        <Message variant="error">Invalid user id.</Message>
      </Box>
    )
  }

  return (
    <Box p={4}>
      <UserDetailHeader user={user} userId={userId} isLoading={isUserPending} />

      <Tabs
        defaultValue="overview"
        tabs={[{ value: 'overview', label: 'Overview' }]}
      >
        <Tabs.Content value="overview">
          <Box py={4}>
            <OverviewTab userId={userId} />
          </Box>
        </Tabs.Content>
      </Tabs>
    </Box>
  )
}

export default UserDetail
